import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

//引入ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 1. 全局引入 particles.js 库
import 'particles.js'

// 添加EventBus
Vue.prototype.$bus = new Vue();

//引入Axios
import axios from 'axios'
import service from './api/service'
// 这允许在任何组件中通过 `this.$http` 访问配置好的 axios 实例。
Vue.prototype.$http = service;
//Vue.prototype.axios=axios

// 在浏览器控制台中禁止“您正在开发模式下运行”的警告。
Vue.config.productionTip = false;


//导入qs框架
import qs from 'qs'
Vue.prototype.qs=qs;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
